import LocalizedStrings from 'localized-strings';

interface CreateNewTransferPinCodeLocalizedType {
  title: string;
  description: string;
}

export default new LocalizedStrings<CreateNewTransferPinCodeLocalizedType>({
  en: {
    description:
      'The security of your account is our priority. Important procedures, such as sending a bank transfer, require your secret code.',
    title: 'Confirm with your passcode',
  },
  fr: {
    description:
      'La sécurité de votre compte est notre priorité. Les démarches importantes comme l’envoi de virement nécessitent votre code secret.  ',
    title: 'Confirmez avec votre code secret',
  },
} as const);
